import React from "react"
import { Helmet } from "react-helmet"
import Phone from "../../components/Shared/Phone"
const classes = require('./WineDinner.module.scss')

const wineDinner = () => {
  return (
    <div className={classes.WineDinner}>
      <Helmet>
        <title>Waterfront Wine Dinners at Mile Marker 158 Dockside</title>
        <meta name="description" content="Check out the next wine pairing at Mile Marker 158 Dockside, located at The Wharf in Orange Beach, Alabama." />
      </Helmet>

      <div className={classes.medDef}>
        <div className={classes.menuArea}>
          <div className={classes.inside}>
            <div className={classes.titleRow}>
              <div className={classes.inner}>
                <h1>March Wine Dinner</h1>
                <h2 className={classes.bold}>
                  March 5th <br className={classes.br1}/>
                  <span className={classes.sp1}>&nbsp;&middot;&nbsp;</span> 6pm <span className={classes.sp2}>&nbsp;&middot;&nbsp;</span> $55 Per Guest
                </h2>
                <h3>Hosted by International Wines</h3>
                <h4>For Reservations: <br className={classes.br400} /> <Phone where="wineDinner" /></h4>
              </div>
            </div>
          </div>


          <div className={[classes.inside, classes.stip].join(' ')}>
            <div className={classes.menuRow}>
              <div className={classes.menuBoxFull}>
                <h5>First Course</h5>
                <h4>Smoked Pork Eggrolls</h4>
                <p>Cabbage, Carrots, Onions, &amp; Ponzu Dipping Sauce</p>
                <p className={classes.pair}>Paired With</p>
                <h4>Barnard Griffin · Riesling · WA '24</h4>
              </div>
 
              <div className={classes.menuBoxFull}>
                <h5>Second Course </h5>
                <h4>Garlic Shrimp Pomodoro</h4>
                <p>Smoked Gouda Polenta Cake, Roasted Red Pepper, &amp; Beurre Blanc</p>
                <p className={classes.pair}>Paired With</p>
                <h4>Barnard Griffin · Pinot Gris · WA '22</h4>
              </div>
              
              <div className={classes.menuBoxFull}>
                <h5>Third Course</h5>
                <h4>Pan Seared Wahoo</h4>
                <p>Shiitake Mushrooms &amp; Brown Butter Sauce, with Smashed Baby Lima Beans &amp; Spinach</p>
                <p className={classes.pair}>Paired With</p>
                <h4>Van Duzer · Pinot Noir · Willamette, OR '23</h4>
              </div>

              <div className={classes.menuBoxFull}>
                <h5>Fourth Course</h5>
                <h4>Chocolate &amp; Strawberry Cannoli</h4>
                <p>Strawberry Rum Sauce</p>
                <p className={classes.pair}>Paired With</p>
                <h4>Mirabello · Prosecco DOC · Veneto, Italy NV</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default wineDinner